import React from 'react';

import Icon, { Props as IconProps } from 'components/Icon';
import {
  Grid,
  Typography
} from 'e100-react-components';

import { useStyles } from './styles';

export const ListItemIcon = ({
  icon,
  iconColor,
  title,
  action,
  subtitle,
  padding
}: ListItemIconProps) => {
  const classes = useStyles({ padding });

  return (
    <Grid
      container
      alignItems="center"
      justify="space-between"
      wrap={'nowrap'}
      spacing={2}
      classes={{
        root: classes.container
      }}
    >
      <Grid
        item
        classes={{ 
          item: classes.iconContainer
        }}
      >
        {
          icon && (
            <Icon
              kind={icon}
              style={{
                color: iconColor
              }}
              classes={{
                root: classes.icon
              }}
            />
          )
        }
      </Grid>
      <Grid
        item
        classes={{ item: classes.checkboxContainer }}
      >
        {
          title && (
            <Typography
              variant={'subtitle2'}
              classes={{
                root: classes.titleRoot
              }}
            >
              {title}
            </Typography>
          )
        }
        {
          subtitle && (
            <Typography
              variant={'caption'}
              color={'secondary'}
            >
              {subtitle}
            </Typography>
          )
        }
      </Grid>
      {
        action && (
          <Grid item>
            {action}
          </Grid>
        )
      }
    </Grid>
  );
};

export interface Padding {
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
}
export interface ListItemIconProps {
  icon?: IconProps['kind'];
  iconColor?: string;
  title?: any;
  subtitle?: string;
  action?: any;
  padding?: Padding;
};
